import React from 'react';
import { motion } from 'framer-motion';
const tomi = [{
  num: '1',
  title: 'Fondamenti del Benessere',
  desc: 'Le basi per uno stile di vita sostenibile.'
}, {
  num: '2',
  title: 'Ricette Veloci Quotidiane',
  desc: 'Piatti sani e gustosi in meno di 20 minuti.'
}, {
  num: '3',
  title: 'Ricette Proteiche Mediterranee',
  desc: 'Equilibrio e sazietà per il tuo metabolismo.'
}, {
  num: '4',
  title: 'Meal Prep Mediterraneo',
  desc: 'Il sistema per risparmiare ore ogni settimana.'
}, {
  num: '5',
  title: 'Ricette Zero Glutine e Zucchero',
  desc: 'Alternative moderne per il tuo benessere.'
}, {
  num: '6',
  title: 'Estate Mediterranea',
  desc: 'Ricette fresche e leggere per la stagione calda.'
}];
export function TomiSection() {
  return <section className="py-6 sm:py-12 px-4 bg-brand-cream" data-id="element-214">
      <div className="max-w-2xl mx-auto" data-id="element-215">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-5 sm:mb-8" data-id="element-216">
          <h2 className="text-xl sm:text-3xl font-serif font-bold text-brand-text-main mb-3 sm:mb-4" data-id="element-217">
            Il Kit Completo "Metodo Mediterraneo"
          </h2>
          <p className="text-sm sm:text-base text-brand-text-muted font-medium" data-id="element-218">
            6 Manuali per trasformare la tua alimentazione
          </p>
        </motion.div>

        <div className="space-y-3 sm:space-y-4" data-id="element-219">
          {tomi.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-white border border-brand-sage/30 p-4 sm:p-5 rounded-xl shadow-sm flex gap-3 sm:gap-4 items-start hover:border-brand-olive/50 transition-colors" data-id="element-220">
              <div className="bg-brand-olive text-white text-xs font-black px-2.5 py-1 rounded shrink-0 mt-0.5" data-id="element-221">
                TOMO {t.num}
              </div>
              <div data-id="element-222">
                <h3 className="font-bold text-brand-olive text-sm sm:text-base mb-1" data-id="element-223">
                  {t.title}
                </h3>
                <p className="text-brand-text-muted text-xs sm:text-sm leading-snug" data-id="element-224">
                  {t.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}